module.exports = __webpack_public_path__ + "static/media/plan-forecast.1277c7b9.svg";